/*
  aycan-gallery-dots — PDP galerisindeki nokta göstergesini aktif slaytla eşitler.

  Neden ayrı: Dawn'ın `slider-counter__link--active` senkronu `SlideshowComponent`
  içinde yaşıyor; ürün galerisi temel `slider-component`'i kullanıyor ve o sınıf
  yalnız `.slider-counter--current` metnini güncelliyor. Nokta göstergesi
  bu yüzden kendi başına hareketsiz kalıyordu.

  Dawn içlerine bağlanmıyoruz: konum doğrudan track'in scrollLeft'inden okunuyor,
  böylece Dawn'ın slider JS'i değişse de bozulmaz.
*/
(function () {
  var ACTIVE = 'slider-counter__link--active';

  function setup(dots) {
    // Modal noktaları track'ini kendi data-attribute'uyla bildiriyor; galeri
    // noktaları ise slider-component'in içinde yaşıyor.
    var track;
    var sel = dots.getAttribute('data-gdots-track');
    if (sel) {
      track = (dots.closest('product-modal') || document).querySelector(sel);
    } else {
      var host = dots.closest('slider-component');
      track = host && host.querySelector('.product__media-list, [id^="Slider-"]');
    }
    if (!track) return;

    var links = Array.prototype.slice.call(dots.querySelectorAll('.slider-counter__link'));
    if (!links.length) return;

    function slides() {
      return Array.prototype.slice.call(track.children).filter(function (el) {
        return el.offsetParent !== null || el.getBoundingClientRect().width > 0;
      });
    }

    function current() {
      var items = slides();
      if (!items.length) return 0;
      // RTL'de scrollLeft negatif olabilir — merkez karşılaştırması yön-bağımsız çalışır.
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var min = Infinity;
      items.forEach(function (el, i) {
        var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - mid);
        if (d < min) {
          min = d;
          best = i;
        }
      });
      return best;
    }

    function paint() {
      var i = current();
      links.forEach(function (el, n) {
        el.classList.toggle(ACTIVE, n === i);
        var btn = el.querySelector('button');
        if (btn) {
          if (n === i) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        }
      });
    }

    var raf;
    track.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          paint();
        });
      },
      { passive: true }
    );

    links.forEach(function (el, n) {
      var btn = el.querySelector('button') || el;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var items = slides();
        var target = items[n];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2,
          behavior: 'smooth',
        });
      });
    });

    window.addEventListener('resize', paint, { passive: true });
    paint();
  }

  function init() {
    document.querySelectorAll('.aycan-gdots').forEach(setup);
    backdrop();
  }

  /* Görsel dışına dokununca kapansın. Dawn modale `cursor: zoom-out` veriyor ama
     kapatmayı yalnız X'e bağlamış; boş alana basmak hiçbir şey yapmıyordu. */
  function backdrop() {
    document.querySelectorAll('product-modal.product-media-modal').forEach(function (modal) {
      if (modal.dataset.backdropBound) return;
      modal.dataset.backdropBound = '1';
      modal.addEventListener('click', function (e) {
        var t = e.target;
        // Görselin, noktaların ve kapatma butonunun kendisi hariç her yer.
        if (t.closest('img, video, model-viewer, .aycan-gdots, .product-media-modal__toggle')) return;
        if (typeof modal.hide === 'function') modal.hide();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Varyant değişiminde galeri yeniden render ediliyor.
  document.addEventListener('shopify:section:load', init);
})();
